export const CONSOLE_VERSION =
  import.meta.env.VERCEL_GIT_COMMIT_SHA ?? 'local';

// Custom headers to identify requests coming from console
export const REQUEST_HEADERS = {
  'Lumeo-Service': 'console',
  'Lumeo-Version': CONSOLE_VERSION,
};
